import React from 'react';

export default function OnlineStatusIndicator({ isOnline }) {
  return (
    <span
      style={{
        width: '10px',
        height: '10px',
        marginTop: '3px',
        borderRadius: '50%',
        backgroundColor: isOnline ? '#39ff14' : 'gray',
        marginRight: '8px'
      }}
    ></span>
  );
}
